<template>
	<div class="advert-manage-container">
		<!-- 搜索条件 -->
		<QueryCard @search="handleSearch" @reset="handleReset">
			<template slot="base">
				<el-col :span="6">
					<el-input v-model="query.triggerSource" placeholder="请输入合同名称" />
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.assetCategory" placeholder="请选择经营类型" clearable style="width: 100%">
						<el-option label="创新租赁" value="创新租赁" />
						<el-option label="委托租售" value="委托租售" />
						<el-option label="增值服务" value="增值服务" />
						<el-option label="房产经纪" value="房产经纪" />
						<el-option label="其他" value="其他" />
					</el-select>
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.assetCategory" placeholder="请选择合同状态" clearable style="width: 100%">
						<el-option label="待生效" value="待生效" />
						<el-option label="生效中" value="生效中" />
						<el-option label="已过期" value="已过期" />
						<el-option label="已中止" value="已中止" />
					</el-select>
				</el-col>
			</template>
		</QueryCard>
		<!-- 表格 -->
		<BaseTable
			:actions="{
				operation: true,
			}"
			:selection="false"
			:loading="loading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="query.pageNum"
			:pageSize="query.pageSize"
			@page-change="pageChange"
			@size-change="sizeChange">
			<template slot="toolbar">
				<el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增合同</el-button>
			</template>
			<template #contractStatus="{ row }">
				<el-tag :type="getContractStatusTag(row.contractStatus)" size="mini">
					{{ row.contractStatus }}
				</el-tag>
			</template>
			<template #operation="{ row }">
				<el-button type="text" icon="el-icon-view" @click="handleDetail(row)">详情</el-button>
				<el-button type="text" style="color: #f56c6c" @click="handleStop(row)" v-if="row.contractStatus === '生效中'">
					中止
				</el-button>
			</template>
		</BaseTable>

		<ContractManagementAddDialog :dialogVisible.sync="dialogVisible" />
		<PartnerManagementDetailDrawer :dialogVisible.sync="drawerVisible" :data="currentRow" />
	</div>
</template>

<script>
	import ContractManagementAddDialog from '@/components/operation/contractManagementAddDialog.vue';
	import PartnerManagementDetailDrawer from '@/components/operation/partnerManagementDetailDrawer.vue';
	export default {
		components: {
			ContractManagementAddDialog,
			PartnerManagementDetailDrawer,
		},
		data() {
			return {
				total: 3,
				query: {
					triggerSource: '',
					pageNum: 1,
					pageSize: 10,
				},
				tableData: [
					{
						contractNo: 'HT-202604-000001',
						contractName: 'A栋广告位租赁合同',
						partyA: '南京智慧物业有限公司',
						partyB: '南京创新科技有限公司',
						projectName: 'A栋广告位创新租赁',
						businessType: '创新租赁',
						contractStatus: '生效中',
						contractPeriod: '2026-01-01 至 2026-12-31',
						receivable: 120000,
					},
					{
						contractNo: 'HT-202603-000002',
						contractName: 'B栋委托租售协议',
						partyA: '南京智慧物业有限公司',
						partyB: '李四军',
						projectName: 'B栋委托租售项目',
						businessType: '委托租售',
						contractStatus: '生效中',
						contractPeriod: '2026-03-01 至 2026-08-31',
						receivable: 50000,
					},
					{
						contractNo: 'HT-202601-000003',
						contractName: '停车场增值服务合同',
						partyA: '南京智慧物业有限公司',
						partyB: '南京停车管理有限公司',
						projectName: '停车场增值服务',
						businessType: '增值服务',
						contractStatus: '已过期',
						contractPeriod: '2026-01-01 至 2026-06-30',
						receivable: 30000,
					},
				],
				columns: [
					{ prop: 'contractNo', label: '合同编号' },
					{ prop: 'contractName', label: '合同名称' },
					{ prop: 'partyA', label: '甲方（我方）' },
					{ prop: 'partyB', label: '乙方（伙伴）' },
					{ prop: 'projectName', label: '关联项目' },
					{ prop: 'businessType', label: '经营类型' },
					{ prop: 'contractStatus', label: '合同状态', slot: 'contractStatus' },
					{ prop: 'contractPeriod', label: '合同起止' },
					{ prop: 'receivable', label: '应收总额' },
				],
				loading: false,
				currentRow: {},
				dialogVisible: false,
				drawerVisible: false,
			};
		},
		methods: {
			getContractStatusTag(status) {
				const contractStatusMap = {
					生效中: 'success',
					已过期: 'info',
					已终止: 'danger',
					草稿: 'warning',
				};
				return contractStatusMap[status] || '';
			},
			getList() {},
			pageChange(page) {
				this.query.pageNum = page;
				this.getList();
			},
			sizeChange(size) {
				this.query.pageSize = size;
				this.getList();
			},
			handleSearch() {
				this.query.pageNum = 1;
				this.getList();
			},
			handleReset() {
				this.query = {
					triggerSource: '',
					pageNum: 1,
					pageSize: 10,
				};
				this.getList();
			},
			handleAdd() {
				this.dialogVisible = true;
			},
			handleDetail(row) {
				this.currentRow = row;
				this.drawerVisible = true;
			},
			handleStop(row) {
				this.currentRow = row;
				this.dialogContractVisible = true;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		text-align: left;
	}
</style>
